import React, { lazy, Suspense } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Space,
} from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { UserForm } from "./UserForm";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import { LanguageContext } from "../../context/LanguageContext.js";
import { AnotherAdminForm } from "./AnotherAdminForm.js";
import { MapAdminCity } from "./MapAdminCity.js";
//import { UsersListTable } from "./UsersListTable";
const UsersListTable = React.lazy(() =>
  import("./UsersListTable.js").then((module) => ({
    default: module.UsersListTable,
  }))
);
const styles = {
  filterRow: {
    padding: "16px",
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  searchInput: {
    flex: "1 1 300px",
    minWidth: "250px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  searchButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: "100px",
  },
  clearButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: "100px",
  },
};

const { Option } = Select;
const FormItem = Form.Item;
let columns = [];
let data = [];
class HomePage extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
  }
  state = {
    isCreateUserDrawerVisible: false,
    isUpdate: false,
    userFormEditData: [],
    resetFrom: false,
    userList: [],
    adminUser: false,
    searchText: "",
    filteredData: [],
    download: "excel",
    isCreateAnotherAdmin: false,
    isNewFormUpdate: false,
    newFormEditData: [],
    resetNewForm: false,
    activeList: "police", // 'police' or 'officer'
    assign_officer: false,
    mapAdminCity: [],
  };
  userForm = React.createRef();
  newFormRef = React.createRef();
  newMapAdminFormRef = React.createRef();

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
  };
  findMapAdminCity = () => {
    userActions.findMapAdminCity().then((res) => {
      this.setState({
        mapAdminCity: res.data,
      });
    });
  };

  download_csv = () => {
    const { t } = this.context;
    // Use the same data as your UsersListTable
    var ReportTitle = t("registered_police_stations");
    var title = t("registered_police_stations");
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const { users } = this.props;
    const { searchText, filteredData } = this.state;
    let tableData =
      users && users.users && users.users.length > 0
        ? filteredData.length > 0 || searchText
          ? filteredData
          : users.users
        : [];

    if (!tableData.length) {
      message.warning("No data to export.");
      return;
    }

    // Prepare data for Excel
    const arrData = tableData.map((item, index) => ({
      "Sr. No": index + 1,
      "User ID": item.userid,
      Name: item.name,
      "Police Station": item.districtName,
      Phone: item.phone,
    }));

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });

    ws["A1"] = {
      v: this.getCityName(this.props?.user?.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 5;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  componentDidUpdate() {
    // const { authentication } = this.props;
    // if(authentication && authentication.user && authentication.user.role==='2'){
    //   return <Redirect to='/login'  />
    // }
  }

  componentDidMount() {
    const { user } = this.props;
    // this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());
    // this.props.dispatch(professionalAction.getDharm());
    // // this.props.dispatch(professionalAction.getKalam());
    // this.props.dispatch(professionalAction.getKayda());
    // this.props.dispatch(professionalAction.getCrimeType());
    // this.props.dispatch(professionalAction.getCrimeTitle());
    // this.props.dispatch(professionalAction.getStatus());
    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(userActions.getAll(user && user.cityId, 2));
    } else if (user && user.role === "8") {
      this.props.dispatch(userActions.getAdminUsers(4));
    }

    // this.props.dispatch(professionalAction.getCity());

    if (user && user.role === "8") {
      // this.props.dispatch(professionalAction.getCity());
      this.findMapAdminCity();
    } else if (user && user.role === "4") {
      this.props.dispatch(
        professionalAction.getDistrict(user && user.cityId, 1)
      );
    }
  }

  handleOfficerOpen = () => {
    this.setState({
      assign_officer: true,
    });
  };
  handleOfficerClose = () => {
    this.setState({
      assign_officer: false,
    });
  };
  onOpenCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: true,
      resetFrom: true,
      isUpdate: false,
    });
  };
  onCloseCrateUserDrawer = () => {
    this.setState({
      isCreateUserDrawerVisible: false,
      resetFrom: false,
      isUpdate: false,
      adminUser: false,
    });
  };

  onOpenCreateAnotherAdmin = () => {
    this.setState({
      isCreateAnotherAdmin: true,
      resetFrom: true,
      isUpdate: false,
    });
  };

  onCloseCreateAnotherAdmin = () => {
    this.setState({
      isCreateAnotherAdmin: false,
      isUpdate: false,
      adminUser: false,
    });
  };
  componentDidUpdate(prevState) {}

  onCityChange = (cityid) => {
    const { user } = this.props;
    if (user && user.cityId && user && user.role === "4") {
      this.props.dispatch(userActions.getAll(cityid, 2));
    }
  };
  // shouldComponentUpdate(nextProps, nextState) {

  //     // if(this.props && this.props.users && this.props.users.error === nextProps && nextProps.users && nextProps.users.error){
  //     //     message.error('Mobile Number Already used')
  //     // }
  //   return false;
  // }

  onFormFinish = (values) => {
    const { user, users, professionals } = this.props;
    console.log("isCreateAnotherAdmin", this.state.isCreateAnotherAdmin);
    console.log("value", values);
    let ob = {
      ...values,
      role: user.role === "8" ? "4" : user.role === "4" ? "2" : null,
      stateId: "1",
      cityId:
        user.role === "8"
          ? values.cityId
          : user.role === "4"
          ? user.cityId
          : null,
    };

    this.props.dispatch(userActions.createUser(ob));
    this.onCloseCrateUserDrawer();
    this.onCloseCreateAnotherAdmin();
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: false,
    }));
  };
  onFormUpdate = (values) => {
    const { id } = this.state.userFormEditData;
    this.props.dispatch(userActions.updateUser(values, id));
    this.onCloseCrateUserDrawer();
    this.onCloseCreateAnotherAdmin();
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: false,
      isUpdate: false,
    }));
  };

  onFormAnotherAdminUpdate = (values) => {
    const { id } = this.state.userFormEditData;
    this.props.dispatch(userActions.updateUser(values, id));
    this.onCloseCrateUserDrawer();
    this.onCloseCreateAnotherAdmin();
    this.setState((prevState) => ({
      isCreateUserDrawerVisible: false,
      isUpdate: false,
    }));
  };
  getDistrictName = (id) => {
    const { basicDistricts } = this.props;
    if (basicDistricts && basicDistricts.length) {
      return (
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(basicDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  onEdituser = (data) => {
    if (this.props.user.role === "8") {
      if (this.state.activeList === "map_admin_city") {
        this.setState((prevState) => ({
          assign_officer: true,
          isUpdate: true,
          userFormEditData: data,
        }));
      } else {
        this.setState((prevState) => ({
          isCreateUserDrawerVisible: true,
          isUpdate: true,
          userFormEditData: data,
        }));
      }
    }
    if (data.role == "2") {
      this.setState((prevState) => ({
        isCreateUserDrawerVisible: true,
        isUpdate: true,
        userFormEditData: data,
      }));
    }
    console.log("role", data);
    if (data.role == "9" || data.role === "10") {
      console.log("test");
      this.setState((prevState) => ({
        isCreateAnotherAdmin: true,
        isUpdate: true,
        userFormEditData: data,
      }));
    }
  };

  onUserFormSave = () => {
    this.userForm.current.onFinish(true);
    //message.success('नवीन वापरकर्ता जोडा is successfully submitted')
  };
  onUserFormUpdate = () => {
    this.userForm.current.onFinish(false);
    //message.success('नवीन वापरकर्ता जोडा is successfully submitted')
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearch = () => {
    const { users } = this.props;
    const { searchText, activeList } = this.state;
    if (!users || !users.users) return;
    const searchStr = searchText.toLowerCase();
    let filtered = users.users.filter((item) => {
      // Role-based filtering
      if (this.props.user.role !== "8") {
        if (activeList === "police" && item.role !== "2") return false;
        if (
          activeList === "officer" &&
          !(item.role === "9" || item.role === "10")
        )
          return false;
      }

      // Search filtering
      return (
        (item.name &&
          item.name.toLowerCase().includes(searchStr.toLowerCase())) ||
        (item.userid &&
          item.userid.toLowerCase().includes(searchStr.toLowerCase())) ||
        (item.phone &&
          item.phone.toLowerCase().includes(searchStr.toLowerCase())) ||
        (item["Police Station"] &&
          item["Police Station"]
            .toLowerCase()
            .includes(searchStr.toLowerCase())) ||
        (item["Unit"] &&
          item["Unit"].toLowerCase().includes(searchStr.toLowerCase()))
      );
    });

    this.setState({ filteredData: filtered });
  };

  clearFilter = () => {
    this.setState({ searchText: "", filteredData: [] });
  };

  onNewFormSave = () => {
    this.newFormRef.current.onFinish(true);
  };
  onNewFormUpdate = () => {
    this.newFormRef.current.onFinish(false);
  };

  onMapAdminFormSave = () => {
    this.newMapAdminFormRef.current.onFinish(true);
  };

  onMapAdminFormUpdate = () => {
    this.newMapAdminFormRef.current.onFinish(false);
  };

  onMapAdminCityFormFinish = (values) => {
    const { user } = this.props;
    let ob = {
      ...values,
      role: "12",
      stateId: "1",
    };
    console.log("obj of another admin", ob);
    userActions
      .saveMapAdminCity(ob)
      .then((res) => {
        message.success(res.message || "User created successfully");
        setTimeout(() => {
          this.handleOfficerClose();
        }, 300);
      })
      .catch((err) => {
        message.error(err);
        this.handleOfficerClose();
      });
  };

  onMapAdminCityFormUpdate = (values) => {
    const { id } = this.state.userFormEditData;
    this.props.dispatch(userActions.updateUser(values, id));
    this.onCloseCrateUserDrawer();
    this.onCloseCreateAnotherAdmin();
    this.handleOfficerClose();
    this.setState((prevState) => ({
      isUpdate: false,
    }));
  };

  onNewFormFinish = (values) => {
    const { user } = this.props;
    let ob = {
      ...values,
      role: values.role,
      stateId: "1",
      cityId:
        user.role === "8"
          ? values.cityId
          : user.role === "4"
          ? user.cityId
          : null,
    };
    console.log("obj of another admin", ob);
    this.props.dispatch(userActions.createUser(ob));
    this.onCloseCrateUserDrawer();
    this.onCloseCreateAnotherAdmin();
    this.setState({ isCreateAnotherAdmin: false });
  };
  onNewFormUpdateFinish = (data) => {
    // handle update logic for new form
    this.setState({ isCreateAnotherAdmin: false, isNewFormUpdate: false });
  };

  render() {
    const { users } = this.props;
    const { user } = this.props;
    const { pc_cities, basicDistricts } = this.props;
    const { language, t } = this.context;
    const { searchText, filteredData, mapAdminCity } = this.state;
    //const requiredKeys = ["userid", "name", "पोलिस ठाणे", "district", "phone"];
    const requiredKeys =
      user.role === "4"
        ? ["userid", "name", "Police Station", "Unit", "phone"]
        : ["userid", "name", "Unit", "phone"];

    // Toggle logic for user list
    let allUsers = users && users.users ? users.users : [];
    let filteredUsers = [];
    if (this.state.activeList === "map_admin_city") {
      filteredUsers = mapAdminCity || [];
    } else if (this.state.activeList === "police") {
      if (user && user.role === "4") {
        filteredUsers = allUsers.filter((u) => u.role == "2");
      } else {
        filteredUsers = allUsers;
      }
    } else {
      filteredUsers = allUsers.filter((u) => u.role == "9" || u.role == "10");
    }
    let tableData =
      filteredUsers.length > 0
        ? this.state.filteredData.length > 0 || this.state.searchText
          ? this.state.filteredData
          : filteredUsers
        : [];
    if (tableData.length > 0) {
      let columns1 = tableData.map((itemObj, index) => {
        return {
          ...itemObj,
          key: index + 1,
          district: this.getDistrictName(itemObj.districtId),
          घटक: this.getCityName(itemObj.cityId),
        };
      });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();
      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    const roleFour = user && user.role === "4" ? "घटक" : "जिल्हा";
    console.log("data", data);
    return (
      <div className="col-md-6 col-md-offset-3">
        <div className="site-page-header-ghost-wrapper">
          <PageHeader
            ghost={false}
            onBack={false}
            // title={user && user.userid}
            // subTitle={
            //   user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
            // }
            extra={[
              <div>
                {this.props.user.role != "8" && (
                  <Button
                    type="primary"
                    className="mb-4"
                    onClick={this.onOpenCreateAnotherAdmin}
                  >
                    {/* {t("add_new_item")} */}
                    {t("add_new_officer")}
                  </Button>
                )}

                <Button
                  type="primary"
                  className="mb-4"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    this.onOpenCrateUserDrawer();
                    this.setState({ adminUser: true });
                  }}
                >
                  {this.props.user.role === "4"
                    ? t("add_new_police_station")
                    : "नवीन घटक जोडा"}
                </Button>
                {this.props.user.role === "8" && (
                  <Button
                    type="primary"
                    className="mb-4"
                    style={{ marginLeft: "5px" }}
                    onClick={() => {
                      this.handleOfficerOpen();
                    }}
                  >
                    Map Admin Officer
                  </Button>
                )}
              </div>,
            ]}
          >
            <Descriptions size="small" column={3}>
              {/* <Descriptions.Item
                label={user && user.role === "8" ? "राज्य" : roleFour}
              >
                {user && user.role === "8"
                  ? "महाराष्ट्र"
                  : "महाराष्ट्र" +
                    " " +
                    "( " +
                    this.getCityName(user && user.cityId) +
                    " )"}
              </Descriptions.Item> */}
              {/* <Descriptions.Item label="Crated Date"> </Descriptions.Item> */}
              <Descriptions.Item label="">
                {/* {
         user && user.role ==='4' ?(
            <Form.Item
              name="city"
              label="पोलीस चौकी"
              style={{width:'100%'}}
            >
              <Select
                style={{width:'100%'}}
                placeholder="Please select an City"
                rules={[{ required: true, message: "Please select an City" }]}
                onChange={this.onCityChange}
              >
                {pc_cities &&
                  pc_cities.length &&
                  pc_cities.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.City}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
         ):null
       } */}
              </Descriptions.Item>
            </Descriptions>
          </PageHeader>
        </div>
        <div className="filter-row">
          {/* Search Bar */}
          <div
            className="search-filter"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 16,
              flexWrap: "wrap",
            }}
          >
            {/* Search Input and Buttons */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Input
                placeholder="Search..."
                value={this.state.searchText}
                onChange={this.handleInputChange}
                prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                style={{ borderRadius: "6px", width: 200 }}
                allowClear
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                className="modern-button modern-button-success"
                disabled={!searchText}
                onClick={this.handleSearch}
              >
                {t("search")}
              </Button>
              {this.state.searchText && (
                <Button
                  onClick={this.clearFilter}
                  className="modern-button modern-button-danger"
                >
                  {t("clear")}
                </Button>
              )}
            </div>

            {/* Total Count */}
            <div
              style={{
                padding: "4px 12px",
                background: "#fff",
                borderRadius: "4px",
                border: "1px solid #d9d9d9",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: 32,
              }}
            >
              <span style={{ color: "#666" }}>{t("total")}:</span>
              <span style={{ fontWeight: "bold" }}>{data.length}</span>
            </div>

            {/* Download Section */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Form>
                <Form.Item
                  name="condition"
                  rules={[{ required: true, message: "Please select a value" }]}
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    defaultValue={this.state.download}
                    placeholder={t("please_select_an_option")}
                    value={this.state.download}
                    onChange={(value) => this.setState({ download: value })}
                    style={{ width: 120 }}
                  >
                    <Option key="excel" value="excel">
                      {t("excel")}
                    </Option>
                  </Select>
                </Form.Item>
              </Form>
              {this.state.download && (
                <Button
                  type="primary"
                  className="download-button-responsive download-button-success"
                  onClick={() => this.downloadReport()}
                >
                  {t("download")}
                </Button>
              )}
            </div>
          </div>
        </div>

        <Drawer
          title={t("add_new_user")}
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseCrateUserDrawer}
          visible={this.state.isCreateUserDrawerVisible}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.onCloseCrateUserDrawer}
                style={{ marginRight: 8 }}
              >
                {t("cancel")}
              </Button>
              {!this.state.isUpdate ? (
                <Button onClick={this.onUserFormSave} type="primary">
                  {t("save")}
                </Button>
              ) : (
                <Button onClick={this.onUserFormUpdate} type="primary">
                  {t("update")}
                </Button>
              )}
            </div>
          }
        >
          <UserForm
            ref={this.userForm}
            user={user}
            adminUser={this.state.adminUser}
            cityData={pc_cities}
            isUpdate={this.state.isUpdate}
            districtData={basicDistricts}
            users={users}
            onFormFinish={this.onFormFinish}
            onFormUpdate={this.onFormUpdate}
            userFormEditData={this.state.userFormEditData}
            resetFrom={this.state.resetFrom}
          ></UserForm>
        </Drawer>
        <Drawer
          title="Add New User"
          placement="right"
          width={720}
          closable={true}
          onClose={this.onCloseCreateAnotherAdmin}
          visible={this.state.isCreateAnotherAdmin}
          footer={
            <div style={{ textAlign: "right" }}>
              <Button
                onClick={this.onCloseCreateAnotherAdmin}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              {!this.state.isUpdate ? (
                <Button onClick={this.onNewFormSave} type="primary">
                  Save
                </Button>
              ) : (
                <Button onClick={this.onNewFormUpdate} type="primary">
                  Update
                </Button>
              )}
            </div>
          }
        >
          <AnotherAdminForm
            ref={this.newFormRef}
            user={user}
            cityData={pc_cities}
            isUpdate={this.state.isNewFormUpdate}
            districtData={basicDistricts}
            users={users}
            onFormFinish={this.onNewFormFinish}
            onFormUpdate={this.onFormAnotherAdminUpdate}
            userFormEditData={this.state.userFormEditData}
            resetFrom={this.state.resetNewForm}
            // any other props you need
          />
        </Drawer>
        <Drawer
          title={t("add_new_user")}
          placement="right"
          width={720}
          closable={true}
          onClose={this.handleOfficerClose}
          visible={this.state.assign_officer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={this.handleOfficerClose}
                style={{ marginRight: 8 }}
              >
                {t("cancel")}
              </Button>
              {!this.state.isUpdate ? (
                <Button onClick={this.onMapAdminFormSave} type="primary">
                  {t("save")}
                </Button>
              ) : (
                <Button onClick={this.onMapAdminFormUpdate} type="primary">
                  {t("update")}
                </Button>
              )}
            </div>
          }
        >
          <MapAdminCity
            ref={this.newMapAdminFormRef}
            mapAdminCity={mapAdminCity}
            adminUser={this.state.adminUser}
            cityData={pc_cities}
            isUpdate={this.state.isUpdate}
            districtData={basicDistricts}
            users={users}
            onFormFinish={this.onMapAdminCityFormFinish}
            onFormUpdate={this.onMapAdminCityFormUpdate}
            userFormEditData={this.state.userFormEditData}
            resetFrom={this.state.resetFrom}
          />
        </Drawer>
        {/* add button */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
          {this.props.user.role != "8" && (
            <Button
              type={this.state.activeList === "officer" ? "primary" : "default"}
              onClick={() =>
                this.setState({ activeList: "officer", filteredData: [] })
              }
            >
              {t("officer_list")}
            </Button>
          )}

          <Button
            type={this.state.activeList === "police" ? "primary" : "default"}
            onClick={() =>
              this.setState({ activeList: "police", filteredData: [] })
            }
          >
            {this.props.user.role === "4"
              ? t("police_station_list")
              : "घटक यादी"}
          </Button>
          {this.props.user.role === "8" && (
            <Button
              type={
                this.state.activeList === "map_admin_city"
                  ? "primary"
                  : "default"
              }
              onClick={() =>
                this.setState({
                  activeList: "map_admin_city",
                  filteredData: [],
                })
              }
            >
              Map Admin City
            </Button>
          )}
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <UsersListTable
            onEdituser={this.onEdituser}
            data={data}
            columns={columns}
            userRole={user}
          />
        </Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };
